import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

export const ScPrizeBlock = styled.div`
  position: absolute;
  z-index: 10;
`;

export const ScWinningPrize = styled.div<{ isOpen: boolean }>`
  overflow: ${({ isOpen }) => (isOpen ? 'scroll' : 'hidden')};
  border-radius: 12px;

  background: ${({
    theme,
  }) => `linear-gradient(${theme.blackColor}, ${theme.blackColor}) padding-box,
    linear-gradient(180deg, #bd5d0d 0%, #ffad01 25.84%, #ffd500 52.78%, #ffad01 80.27%, #bd5d0d 105.56%) border-box`};
  border: 4px solid transparent;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  & .inside {
    max-width: 367px;
    width: 100%;
    margin: 0 auto;
    padding: 24px 32px;

    ${({ isOpen }) =>
      !isOpen &&
      css`
        height: 100%;
      `};

    @media (${device.mobile}) {
      padding: 16px;
      max-width: 312px;
    }
  }

  & .congrats {
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.56px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 32px;

    @media (${device.mobile}) {
      font-size: 24px;
      margin-bottom: 20px;
    }
  }

  & .description {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.01em;
    text-align: center;
    margin-bottom: 8px;

    @media (${device.mobile}) {
      font-size: 14px;
    }
  }

  & .prize-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 8px 0 32px;

    @media (${device.mobile}) {
      margin: 4px 0 20px;
    }
  }

  & .prize-value {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .prize {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.03em;
    margin-right: 8px;
    text-transform: capitalize;

    @media (${device.mobile}) {
      font-size: 22px;
      line-height: 28px;
      margin-right: 8px;
    }
  }

  & .info-text {
    padding: 8px;
    text-align: center;
    background: ${({ theme }) => theme.color1};
    border-radius: 12px;

    font-size: 14px;
    font-weight: 400;
    line-height: 110%;

    @media (${device.mobile}) {
      font-size: 10px;
    }
  }

  & .info-btn {
    position: relative;
    display: inline-flex;
    cursor: pointer;
  }

  & .btn-container {
    position: relative;
    max-width: 280px;
    width: 100%;
    margin: 0 auto;
  }

  & .btn_wrapper {
    display: flex;
    justify-content: center;
  }
`;

export const ScTermsSection = styled.div<{ isOpen: boolean }>`
  position: relative;
  margin-top: 16px;

  & .header {
    padding-bottom: 24px;
  }

  .content-box {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};

    & .content {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-break: break-word;
      text-align: left;
    }

    & .bonus {
      text-transform: capitalize;
    }
  }
`;

export const ScTermsButton = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  column-gap: 8px;
  font-size: 14px;
  line-height: 20px;

  & > i {
    transition: rotate 0.2s ease-in-out;
    rotate: ${({ isOpen }) => (isOpen ? '-90deg' : '90deg')};
  }

  @media (hover: hover) {
    &:hover {
      & > i {
        rotate: -90deg;
      }
    }
  }
`;
